import { useState } from 'react';
import { CheckCircle2, Download, Share, SquarePlus } from 'lucide-react';
import { usePwaInstall } from '../hooks/usePwaInstall';
import { Modal } from './Modal';

/** "Voeg toe aan beginscherm": native prompt waar mogelijk, anders stapsgewijze uitleg. */
export function InstallCard() {
  const { isInstalled, isIOS, install } = usePwaInstall();
  const [showGuide, setShowGuide] = useState(false);

  if (isInstalled) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
        <CheckCircle2 size={18} /> <span className="whitespace-nowrap">Geïnstalleerd / App-modus actief</span>
      </div>
    );
  }

  const onInstall = async () => {
    if (!(await install())) setShowGuide(true);
  };

  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="font-semibold">Voeg toe aan beginscherm</p>
          <p className="text-sm text-slate-600 dark:text-slate-400">Open de app direct, ook offline.</p>
        </div>
        <button
          onClick={onInstall}
          className="flex min-h-11 items-center gap-2 whitespace-nowrap rounded-2xl bg-slate-900 px-4 text-sm font-semibold text-slate-50 transition-all duration-150 active:scale-95 dark:bg-slate-100 dark:text-slate-900"
        >
          <Download size={18} /> Installeer
        </button>
      </div>

      {showGuide && (
        <Modal title="Voeg toe aan beginscherm" onClose={() => setShowGuide(false)}>
          {isIOS ? (
            <ol className="space-y-4 text-sm">
              <li className="flex items-center gap-3"><Share size={20} /> Tik onderin op 'Delen'</li>
              <li className="flex items-center gap-3"><SquarePlus size={20} /> Kies 'Zet op beginscherm'</li>
            </ol>
          ) : (
            <p className="text-sm">
              Open het browsermenu en kies 'App installeren' of 'Toevoegen aan startscherm'.
            </p>
          )}
        </Modal>
      )}
    </>
  );
}
